/** @format */

import { actionTypes } from './actions'

const initialState = []

export const databaseReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.DATABASE_ADD:
      return [...state, payload]
    case actionTypes.DATABASE_REMOVE:
      return state.filter((el) => el.age !== payload)
    case actionTypes.DATABASE_DEFAULT:
      return initialState
    case actionTypes.DATABASE_FETCH_SUCCESS:
      return [...state, ...payload]
    case actionTypes.DATABASE_FETCH_ERROR:
      return state
    default:
      return state
  }
}
